<template>
	<div v-if="!pending">
		<Header />
		<div class="content">
			<section class="board-control">
				<div class="container">
					<div
						v-if="error"
						class="message">
						<p class="error">
							Error: {{ error }}
						</p>
					</div>
					<router-view v-else-if="account" />
					<LoginWallet v-else />
				</div>
			</section>
		</div>
		<Footer />
	</div>
</template>

<script setup>
import { onMounted } from 'vue';

import { useWallet } from '@/composables/wallet';

import Header from '@/components/Layout/Header.vue';
import Footer from '@/components/Layout/Footer.vue';
import LoginWallet from '@/components/LoginWallet.vue';

const {
	pending,
	error,
	account,

	autoConnectWallet,
} = useWallet();

onMounted(() => {
	autoConnectWallet();
});
</script>
